import { BaseService } from './BaseService'
const USER_LOCATION_PATH = '/send-user-location'
const GET_USER_LOCATION_PATH = '/get-user-location'
/* eslint-disable */ 
class LocationService extends BaseService {
  setUserLocations (formData) {
    return this.post(USER_LOCATION_PATH, formData)
  }
  getUserLocation () {
    return this.get(GET_USER_LOCATION_PATH)
  }
}
export default new LocationService()
/* eslint-disable */ 
